import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

import { Currency } from 'ha/constants/Currencies';

export interface Amount {
  currencyCode?: Currency;
  cents?: number;
}

export interface PayoutMethod {
  method?: string;
  details?: string;
}

// @types https://github.com/housinganywhere/ha/blob/761a482e4b2ea3cdaa3f8b94ae3711da8eb678aa/types/payout_transaction.go#L9-L27
export interface Transaction {
  payoutID: { ID: string };
  date: string;
  tenantID: number;
  tenantName: string;
  moveInDate: string;
  moveOutDate: string;
  amount: Amount;
  invoiceNumber: string;
  invoiceURL: string;
  status: string;
  payoutMethod: PayoutMethod;
}

export interface TransactionsResponse {
  totalCount: number;
  payouts: Transaction[];
}

export type TransactionStatus = 'all' | 'completed' | 'upcoming';

// @link http://localhost:5000/api#/paths/~1user~1{userId}~1payout-transactions/get
export interface TransactionsFilters {
  fromDate?: string;
  limit?: number;
  offset?: number;
  status?: TransactionStatus;
  toDate?: string;
}

export const getTransactionHistory = (makeCall: MakeCall) => (
  filters?: TransactionsFilters,
) =>
  makeCall<TransactionsResponse>(
    'GET',
    `${APIV2_URL}/user/me/payout-transactions`,
    { query: filters },
  );

export default getTransactionHistory;
